import { render, staticRenderFns } from "./BestaetigenAbholung2.vue?vue&type=template&id=b3d67480"
import script from "./BestaetigenAbholung2.vue?vue&type=script&lang=ts"
export * from "./BestaetigenAbholung2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports